'use client';

import { signIn, useSession } from 'next-auth/react';

import { Button } from 'components/ui/button';

export function LoginButtonMBAG() {
  const { status } = useSession();
  const loading = status === 'loading';

  async function handleLogin() {
    await signIn('mbag', { callbackUrl: '/' });
  }

  return (
    <Button
      loading={loading}
      onClick={handleLogin}
      className="w-full flex items-center bg-[#212731] text-white hover:bg-[#CDCFD1] border-[#212731]"
      // icon={<AzureLogo />}
    >
      <span>Sign in with GAS (MBAG)</span>
    </Button>
  );
}
